// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2MWUt","content":"ManualTimeModal_content__1yzPE"};